import React, {Component} from "react";
import {MetricCombobox} from "../dashboard/MetricCombobox";
import {fetchCustomMetrics, filterForGoals} from "../../hooks/useCustomMetrics";


export class MetricsSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            customMetrics: [],
            customLoaded: !props.includeCustomMetrics,
        };
    }

    componentDidMount() {
        if (!this.props.includeCustomMetrics) return;
        // UI-3: solo métricas resolubles por Backend (Goals + FlexIndicators).
        // Las marcadas is_goals_evaluable=false o has_broken_reference=true se ocultan
        // para evitar "—" silencioso cuando la fórmula referencia un field Data-Node-only.
        fetchCustomMetrics().then((items) => {
            this.setState({customMetrics: filterForGoals(items), customLoaded: true});
        });
    }

    render() {
        return (
            <MetricCombobox
                name={this.props.name}
                value={this.props.value || null}
                disabled={this.props.disabled}
                customMetrics={this.state.customMetrics}
                onChange={(metricName) => this.props.onChange({target: {name: this.props.name, value: metricName}})}
            />
        );
    }
}
